import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const MobileChromeContext = createContext({
  bottomNavHidden: false,
  setBottomNavHidden: () => {},
  hideBottomNav: () => {},
  showBottomNav: () => {},
});

export function MobileChromeProvider({ children }) {
  const [bottomNavHidden, setBottomNavHidden] = useState(false);

  const hideBottomNav = useCallback(() => setBottomNavHidden(true), []);
  const showBottomNav = useCallback(() => setBottomNavHidden(false), []);

  const value = useMemo(() => ({
    bottomNavHidden,
    setBottomNavHidden,
    hideBottomNav,
    showBottomNav,
  }), [bottomNavHidden, hideBottomNav, showBottomNav]);

  return (
    <MobileChromeContext.Provider value={value}>
      {children}
    </MobileChromeContext.Provider>
  );
}

export function useMobileChrome() {
  return useContext(MobileChromeContext);
}
